import React, { FC } from 'react';

import { TableCell, Typography } from '@material-ui/core';

import { CellProps } from '../../../const';

const LabelWithHelperTextCell: FC<CellProps> = ({ row, k, styles, align }) => {
  const label = row[k]?.label || '';
  const helperText = row[k]?.helper || '';

  return (
    <TableCell key={k} className={styles.contentCell} align={align} title={label}>
      {label}
      <Typography className={styles.meta}>{helperText}</Typography>
    </TableCell>
  );
};

export default LabelWithHelperTextCell;
